import { FansLevel, Time, Pay } from '../models/Fee';

export interface UpgradeState {
  level: number;
  isAll: boolean;
  time: number;
  promoCode?: string;
  promoFee?: number;
  prePromoFee?: number;
  modules: string[];
  fee: number;
  payType: number;
  discount?: any;
}

export const upgradeState: UpgradeState = {
  level: FansLevel.Level1,
  isAll: true,
  time: Time.OneYear,
  promoCode: '10000',
  promoFee: 100,
  modules: [],
  fee: 0,
  payType: Pay.Wx,
  discount: null,
};

